module.exports = __webpack_public_path__ + "img/favorites.db8ea105.svg";